export const ROUTES = {
  HOME: '/',

  // General
  ABOUT_US: '/about-us',
  CONTACT_US: '/contact-us',
  GROUPS: '/groups',
  TRAVEL: '/travel',
  PRIVACY: '/privacy',
  LOGIN: '/login',
  TERMS: '/terms',
  BUYERS_GUARENTEE: '/100-buyers-guarantee',
  FANATICS: '/fanatics',
  FLIGHT_REQUEST: '/flight-request',

  EVENT_LIST: '/event/list',

  // PACKAGE
  PACKAGE: {
    BASE: '/package',
    TICKET_SELECT: '/package/tickets/{packageId}',
    ADD_ONS: '/package/addons',
    HOTEL_SEARCH: '/package/hotel/search',
    HOTEL_RESULTS: '/package/hotel/results',
    HOTEL_DETAILS: '/package/hotel/details/{hotelId}',
    FLIGHTS_SEARCH: '/package/flights/search',
    FLIGHTS_DEPARTURE: '/package/flights/departure',
    FLIGHTS_RETURN: '/package/flights/return/{departureId}',
    SESSION_EXPIRED: '/package/session-expired',
    CONTACT_INFO: '/package/review/contact-info',
    REVIEW_PACKAGE: '/package/review',
    CHECKOUT: '/package/checkout',
    ORDER: {
      IN_PROGRESS: '/package/order/in-progress',
    },
    ORDER_INCOMPLETE: '/package/order-incomplete',
    ORDER_CONFIRMATION: '/package/order-confirmation',
  },

  USER: {
    PROFILE: '/user/profile',
  },

  // ERRORS
  SERVER_ERROR: '/something-went-wrong',
}

export const URL_PARAMS = {
  REFERENCE_URL: 'referenceUrl',
  RETRY_COUNT: 'retryCount',
}
